import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentV2Service, ScriptLoaderService, UtilService, VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';
import { ICard } from '../payment/models/card.model';
import { CARD_CONFIG } from './card-config';

declare let cardValidator;

@Component({
  selector: 'app-payment-sip-card',
  templateUrl: './payment-sip-card.component.html',
  styleUrls: ['./payment-sip-card.component.scss']
})
export class PaymentSipCardComponent implements OnInit, OnChanges {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter;

  cardConfig = CARD_CONFIG;
  card: ICard;
  cardValidation;

  cardForm: FormGroup = new FormGroup({
    number: new FormControl('', [Validators.required]),
    expiry: new FormControl('', [Validators.required]),
    cvv: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
  });

  constructor(
    private script: ScriptLoaderService,
    private util: UtilService,
    private paymentV2: PaymentV2Service,
    public vwo: VwoService
  ) { }

  ngOnChanges() {
    if (this.util.checkNestedObj(this.config, 'user.full_name') && this.cardForm.get('name')) {
      this.cardForm.patchValue({
        name: this.config.user.full_name
      });
    }
    if (this.util.checkNestedObj(this.config, 'user.pincode') && this.cardForm.get('pincode')) {
      this.cardForm.patchValue({
        pincode: this.config.user.pincode
      });
    }
    this.togglePincode(this.config.currency !== 'INR');
  }

  ngOnInit() {
    this.script.load('card-validator');
    this.submitForm();
  }

  submitForm() {
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'card' || (tab === 'bank' && !this.config.selectEmandateBank)) {
        if (this.cardForm.valid) {
          const exp = this.cardForm.get('expiry').value.split('/');
          const payload = {
            mode: 'CARD',
            mode_value: this.card.card_type.toUpperCase(),
            card_number_fill: this.cardForm.get('number').value.toString().trim(),
            card_month_fill: exp[0],
            card_year_fill: exp[1],
            card_cvv_fill: this.cardForm.get('cvv').value,
            card_name_fill: this.cardForm.get('name').value,
          };
          if (this.cardForm.get('pincode')) {
            payload['donor_pincode'] = this.cardForm.get('pincode').value;
          }
          this.dataEmit.emit(payload);
        } else {
          this.util.checkValidForm(this.cardForm);
        }
      }
    });
  }

  togglePincode(value) {
    this.cardConfig.pincode.show = value;
    if (value && !this.cardForm.get('pincode')) {
      this.cardForm.addControl('pincode', new FormControl('', [Validators.required]));
    }
    if (!value && this.cardForm.get('pincode')) {
      this.cardForm.removeControl('pincode');
    }
  }

  onInputChange(value, name) {
    if (name === 'number') {
      this.cardValidation = cardValidator(value);
      this.card = this.cardValidation.getCardDetails();
      this.cardConfig.number.mask = this.addMask(this.card.max_length, this.card.gaps);
      this.checkForCvv();
    }

    // If input is valid then move cursor to next input field
    try {
      if (name === 'number') {
        if (this.cardValidation.validateCard(value)) {
          document.getElementById('card-expiry').focus();
        }
      } else if (name === 'expiry') {
        if (this.validateExpiry(value)) {
          document.getElementById('card-cvv').focus();
        }
      } else if (name === 'cvv' && this.cardForm.get('pincode')) {
        if (this.cardValidation.validateCvv(value)) {
          document.getElementById('card-pincode').focus();
        }
      }
    } catch (error) { }
  }

  @HostListener('blur', [])
  onInputBlur(value, name) {
    if (name?.match('number|expiry|cvv')) {
      try {
        let data;
        if (name === 'number') {
          data = this.cardValidation.validateCard(value);
        } else if (name === 'expiry') {
          data = this.validateExpiry(value);
        } else if (name === 'cvv') {
          data = this.cardValidation.validateCvv(value);
        }
        this.setControlValidations(name, data ? null : true, `Invalid ${name}`);
      } catch (exception) {
        this.setControlValidations(name, true, exception);
      }
    }
  }

  validateExpiry(value: string) {
    const exp = value.replace(/\s/g, '').split('/');
    if (exp[1] && exp[1].length === 2) {
      exp[1] = '20' + exp[1];
    }
    return this.cardValidation.validateExpiry(exp.join('/'));
  }

  checkForCvv() {
    if (this.card.cvv_length) {
      if (!this.cardForm.get('cvv')) {
        this.cardForm.addControl('cvv', new FormControl('', [Validators.required]));
      }
      this.cardConfig.cvv.mask = this.addMask(this.card.cvv_length[this.card.cvv_length.length - 1]);
      this.cardConfig.cvv.show = true;
    } else {
      this.cardForm.removeControl('cvv');
      this.cardConfig.cvv.show = false;
    }
  }

  /**add masking to the input */
  addMask(length, gaps?) {
    let mask = '';
    for (let i = 1; i <= length; i++) {
      mask = mask.concat('0');
    }
    if (gaps) {
      for (let i = 0; i < gaps.length; i++) {
        mask = mask.substr(0, (gaps[i] + i)) + ' ' + mask.substr(gaps[i] + i);
      }
    }
    return mask;
  }

  setControlValidations(name, invalid, error?) {
    this.cardConfig[name].error = error;
    this.cardForm.controls[name].setErrors({ invalid: invalid });
    if (!invalid) {
      this.cardForm.controls[name].updateValueAndValidity();
    }
  }

}
